<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <a v-on:click="$root.back()" class="back hidden-xs hidden-md">
                        <i class="material-icons">arrow_back</i>
                        Voltar
                    </a>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}

                            <button class="button block-mobile big margin-bottom-10 float-right margin-left-10 gray" style="margin-top: -25px;" v-bind:class="{'disabled': !form.empresaCod || !form.estoqueCod || !form.ano || !form.mes}" v-show="form.empresaCod && form.ano && form.mes && form.estoqueCod" v-on:click="imprimir()">
                                <i class="material-icons">print</i>
                                Imprimir
                            </button>

                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">

                        <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12">

                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-3 col-md-6 col-xs-12 col-xl-3" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                        <div class="submit-field">
                                            <h5>Selecione a filial:</h5>
                                            <select class="with-border" v-model="form.empresaCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-xs-12 col-xl-3" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Selecione o tanque:</h5>
                                            <select class="with-border" v-model="form.estoqueCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in estoque.itens" v-if="item.empresaCod == form.empresaCod && item.tipo == 'tanque'" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>                                         
                                    <div class="col-lg-3 col-md-4 col-xs-6 col-xl-3" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Mês:</h5>
                                            <select class="with-border" v-model="form.mes">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option value="1" selected>Janeiro</option>
                                                <option value="2" selected>Fevereiro</option>
                                                <option value="3" selected>Março</option>
                                                <option value="4" selected>Abril</option>
                                                <option value="5" selected>Maio</option>
                                                <option value="6" selected>Junho</option>
                                                <option value="7" selected>Julho</option>
                                                <option value="8" selected>Agosto</option>
                                                <option value="9" selected>Setembro</option>
                                                <option value="10" selected>Outubro</option>
                                                <option value="11" selected>Novembro</option>
                                                <option value="12" selected>Dezembro</option>
                                            </select>                                            
                                        </div>
                                    </div>    
                                    <div class="col-lg-2 col-md-2 col-xs-6 col-xl-2" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Ano:</h5>
                                            <input type="number" v-model="form.ano" class="with-border">
                                        </div>
                                    </div>   

                                    <div class="col-lg-12 hidden-lg hidden-xl hidden-md" v-show="form.empresaCod && form.ano && form.mes && form.estoqueCod">
                                        <button class="button block-mobile big gray" v-bind:class="{'disabled': !form.empresaCod || !form.estoqueCod || !form.ano || !form.mes}" v-on:click="imprimir()">
                                            <i class="material-icons">print</i>
                                            Imprimir
                                        </button>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 


                            <div class="table-scroll" style="overflow-x: scroll;" v-show="form.empresaCod && form.ano && form.mes && form.estoqueCod">

                                <table class="table table-bordered table-bordered-default table-responsive margin-bottom-0">
                                    <thead>
                                        <th style="min-width: 120px; width: 120px;">
                                            DATA DE RECEBIMENTO
                                        </th>
                                        <th style="min-width: 80px; width: 80px;">
                                            HORA
                                        </th>
                                        <th style="min-width: 80px; width: 80px;">
                                            QUANTIDADE (LITROS)
                                        </th>                                             
                                        <th style="min-width: 120px; width: 120px;">
                                            DENS OBS.
                                        </th>
                                        <th style="min-width: 120px; width: 120px;">
                                            TEMP (C.)
                                        </th>
                                        <th style="min-width: 120px; width: 120px;">
                                            DENS A 20C.
                                        </th>     
                                        <th style="min-width: 120px; width: 120px;">
                                            NFE
                                        </th>                                                                                                                        
                                        <th style="min-width: 120px;">
                                            OBSERVAÇÃO
                                        </th>    
                                        <th style="width: 1%">
                                            
                                        </th>                                                                                                                                                      
                                    </thead>
                                    <tbody> 
                                        <tr v-for="(item, index) in form.itens">
                                            <td data-label="" class="hidden-lg hidden-xl hidden-md">
                                                Item #{{index+1}}    
                                                <button type="button" class="button" v-on:click="del(item.cod)" style="float: right; margin-top: -15px !important;">
                                                    <i class="material-icons">close</i>
                                                </button>                                                                              
                                            </td>                                            
                                            <td data-label="Data de recebimento:">
                                                <the-mask :mask="['##/##/####']" :masked="true" type="tel" class="with-border" placeholder="___ /____ /_____" style="width: 170px" v-model="item.data" />
                                            </td>

                                            <td data-label="Hora:">
                                                <the-mask :mask="['##:##']" :masked="true" type="tel" class="with-border" placeholder="___ : ___" style="width: 80px;" v-model="item.hora" />
                                            </td>

                                            <td data-label="Quantidade (L):">
                                                <input type="number" name="" placeholder="______________" required="" v-model="item.quantidade" style="width: 114px;">                                                  
                                            </td>

                                            <td data-label="Dens Obs. (C.):">
                                                <input type="text" name="" placeholder="______________" required="" data-placeholder="____" v-model="item.densidade"  style="width: 120px;">                                                  
                                            </td> 

                                            <td data-label="Temperatura (C.):">
                                                <input type="number" name="" placeholder="____________________" required="" data-placeholder="____" v-model="item.temperatura" style="width: 120px;">                                                  
                                            </td> 

                                            <td data-label="Dens. a 20C.:">
                                                <input type="number" name="" placeholder="____________________" required="" data-placeholder="____" v-model="item.densidade20"  style="width: 120px;">                                                  
                                            </td>                 

                                            <td data-label="NFE:">
                                                <input type="number" name="" placeholder="______________________" required="" data-placeholder="____" v-model="item.nfe" style="width: 120px;">                                                  
                                            </td>                 

                                            <td data-label="Observação:">
                                                <input type="text" name="" placeholder="___________________________________" required="" data-placeholder="____" v-model="item.observacao">                              
                                            </td>                                                                                                                                                                                

                                            <td data-label=""  style="padding-left: 2px; padding-right: 2px;">
                                                <button type="button" class="button hidden-xs" v-on:click="del(item.cod)">
                                                    <i class="material-icons">close</i>
                                                </button>
                                            </td>                                                                                             
                                        </tr>                      
                                    </tbody>
                                </table>

                                <a class="button small gray margin-top-10 margin-bottom-20" v-on:click="add">
                                    <i class="material-icons">add</i>
                                    Adicionar linha
                                </a>

                            </div>
                        </div>                    
                        <div class="col-xl-12" v-show="form.empresaCod && form.ano && form.mes && form.estoqueCod">

                            <button type="button" v-on:click="submit" class="button ripple-effect big block-mobile green margin-top-10">
                                <i class="material-icons">save</i>
                                Salvar alterações
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'GerenciarEstoqueArmazenamento',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "clientes": {
                "itens":            []
            },
            "empresas": {
                "itens":            []
            },
            "estoque": {
                "itens":            []
            },            
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "controle-tanque-armazenamento",
                "empresaCod":       "",
                "estoqueCod":       "",
                "mes":              (new Date().getMonth()+1),
                "ano":              (new Date().getFullYear()),
                "itens":            []
            },
        }
    },
    watch: {
        "form.empresaCod": function(val) {
            console.log("watch > form.empresaCod", val);
            var self            = this;
            self.form.estoqueCod= "";
            self.form.itens     = [];
            self.$forceUpdate();
            self.get();
          
        },
        "form.estoqueCod": function(val) {
            console.log("watch > form.estoqueCod", val);
            var self            = this;
            self.form.itens     = [];
            self.$forceUpdate();                
            self.get();
          
        },        
        "form.ano": function(val) {
            console.log("watch > form.ano", val);
            var self            = this;
            self.form.itens     = [];
            self.$forceUpdate();    
            self.get();
            
        },
        "form.mes": function(val) {
            console.log("watch > form.mes", val);
            var self = this;
            self.form.itens     = [];
            self.$forceUpdate();
            self.get();
        
        }                
    },
    methods: {             
        add: function() {
            console.log("add")
            var self            = this;

            // id
            // cod
            // estoqueCod
            // empresaCod
            // grupo
            // nome
            // valor
            // ano
            // mes
            // ativo
            // datahora

            self.form.itens.push({
                "data":         "",
                "hora":         "",
                "quantidade":   "",
                "temperatura":  "",
                "observacao":   "",
                "densidade":    "",
                "densidade20":  "",
                "nfe":          ""
            });
        },
        del: function(item) {
            var self = this;
            confirm("Você tem certeza que deseja remover este item?", function() {
                var index = self.form.itens.indexOf(item);
                self.form.itens.splice(index, 1);
            });
        },   
        imprimir: function() {
            var self = this;

            var form    = JSON.parse(JSON.stringify(self.form));
            delete      form.itens;

            var tipo = "_blank";
            if (window.cordova)  {
                tipo = "_system";
            }
            window.open(self.$root.config.url + "/relatorio.php?" + (new URLSearchParams(form).toString()), tipo);
        },           
        getEstoque: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "estoque",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "group":        false
                    }
                };

                axios.get("api/estoque.php", form)
                .then(response => {
                    
                    console.log("getEstoque() result", response.data);
                    self.estoque.itens  = response.data.result.itens;
                    resolve(response.data.result);

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },                 
        submit: function() {
            var self            = this;
            console.log("submit()", self.form);
            
            self.loading.submit = true;
            loading.show();
                
            axios.put("api/itens.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },        
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin" && self.$root.user.tipo != "gerencial") {
                    resolve(true);
                    return false;
                }

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },                  
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            self.form.itens = [];
            self.loaded     = false;
            return new Promise(function(resolve, reject) {

                if (!self.form.empresaCod || !self.form.estoqueCod || !self.form.ano || !self.form.mes) {
                    console.log("Nao possui todos os campos", self.form);
                    reject("Informe todos os campos");
                    return false;
                }

                loading.show();

                var form = {
                    "db":               "estoqueArmazenamento",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "empresaCod":   self.form.empresaCod,
                        "estoqueCod":   self.form.estoqueCod,
                        "ano":          self.form.ano,
                        "mes":          self.form.mes,
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    self.form.itens         = response.data.result.itens; 
                    self.loaded             = true;
                    loading.hide();
                    resolve(response.data.result);
                    self.$root.scrollTop();
                    if (response.data.result.itens.length == 0) {
                        self.add();
                    }
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        init: function() {
            var self = this;
            Promise.all([
                // self.get(),
                self.getEmpresas(),
                self.getEstoque(),
            ]).then(function() {
            
                self.$forceUpdate();
                loading.hide();
                
            }).catch(function(error) {
                loading.hide();
            });             
        }
    },
    created: function() {
        var self = this;

        if (self.$root.user.tipo == "prestador") {
            self.form.empresaCod    = self.$root.user.empresaCod;
        } 

        loading.show();
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }           

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #000;
    }
    .table td button {
        padding-left: 4px;
        padding-right: 4px;
        margin-top: 0px !important;
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
    }
    .table td {
        padding-bottom: 0px;
        padding-top: 0px;
        padding-left: 0px;
        padding-right: 0px;
        /*border-right: none;*/
        /*border-left: none;*/
    /*padding: 2px !important;*/
    }
    .table th {
        padding-left: 10px;
        padding-right: 10px;
        /*text-align: center;*/
    }
    .table td input, .table td select {
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        padding-left: 10px;
        padding-right: 10px;
        text-align: left;
        box-shadow: none;
        border: none;
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .back {
        color: #666;
        font-size: 14px;
        position: absolute;
        top: 10px;
    }
    .back i {
        font-size: 16px;
        position: relative;
        top: 2px;
    }      
    @media only screen and (max-width: 500px) { 
        .table td input, .table td select {
            border: 1px solid #ddd;
            padding-left: 10px;
            padding-right: 10px;
        }
        .table td {
            padding-bottom: 10px;
            padding-top: 10px;
            padding-left: 10px;
            padding-right: 10px;
        }        
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarEstoqueArmazenamento.vue